import Box from 'components/shared/Box'
import BungalowDetails from 'components/shared/BungalowDetails'
import Section from 'components/shared/Section'
import Text from 'components/shared/Text'
import { scrollToTop } from 'helpers/animateScroll'
import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useAppSelector } from 'store/hooks'
import { useResolutions } from 'store/resolutions'

const AllGuestDetails = () => {
    const { isTablet } = useResolutions()
    const { bungalows } = useAppSelector((state) => state.accommodation)

    useEffect(() => {
        isTablet && scrollToTop(1000)
    }, [])

    return (
        <Section>
            <Box gap={24} isFullWidth>
                <Text variant="heading2">
                    <FormattedMessage
                        id="accommodation.all_guest_details"
                        defaultMessage="Uzupełnij dane wszystkich gości"
                    />
                </Text>
                <>
                    {bungalows.map((bungalow, index) => (
                        <BungalowDetails
                            key={`BungalowsDetails${index}`}
                            bungalowIndex={index}
                            allGuestDetails={bungalow}
                        />
                    ))}
                </>
            </Box>
        </Section>
    )
}

export default AllGuestDetails
